<template>
    <!-- <div>
    <img :src="verdeImage" alt="Mindef Image">
  </div> -->
    <!-- <v-parallax src="@/assets/verde.jpg"> -->


        <div class="mx-1 my-1">
            <v-btn style="font-size: 11px;" class="ma-2" color="black" variant="outlined" disabled>VER<v-icon color="cyan" end icon="mdi-eye" disabled></v-icon></v-btn>
      <v-btn style="font-size: 11px;" class="ma-2" color="black" variant="outlined" disabled>Imp. Certificado<v-icon color="red" end icon="mdi-file-pdf-box" disabled></v-icon></v-btn>
            <v-card>
                <v-alert v-if="showAlert" type="success" title="Registrado !!!"
                    text="Se ha registrado correctamente el Repuesto Pistola.">
                    <v-icon @click="cerrarDialogo" class="m-1 position-absolute top-0 end-0" color="blue-lighten-5"
                        icon="mdi-close-circle"></v-icon>
                </v-alert>
                <v-card-title>
                    <v-text-field v-model="search" append-icon="mdi-magnify" color="light-blue-darken-4" label="Buscar"
                        single-line hide-details></v-text-field>
                </v-card-title>
                <v-data-table :headers="headers" :items="registros" :search="search">
                    <template v-slot:[`item.actions`]="{ item }">
                        <v-icon @click="abrirDialogo(item)" class="m-1" color="cyan-lighten-2" icon="mdi-eye">
                        </v-icon>
                        <v-icon @click="generarCertificacion(item)" class="m-1" color="red-darken-2" icon="mdi-file-pdf-box">
                        </v-icon>
                    </template>
                <template v-slot:[`item.num`]="{ item }">
            {{ item.num }}
          </template>
                </v-data-table>
            </v-card>
            <v-dialog v-model="dialogoAbierto" max-width="500px">
                <v-card>
                    <v-card-title> Contenido Individual </v-card-title>
                    <v-card-text>
                        <div><strong>ID: </strong> {{ id }}</div>
                        <div><strong>NOMBRE_COMPLETO: </strong> {{ nombre_completo }}</div>
                        <div><strong>CARNET: </strong> {{ carnet }}</div>
                        <div><strong># CUCHILLO: </strong> {{ nro_cuchillo }}</div>
                        <div><strong>MARCA: </strong> {{ marca }}</div>
                        <div><strong>DESCRIPCIÓN: </strong> {{ descripcioncu }}</div>
                        <div><strong>MODELO: </strong> {{ modelo }}</div>
                        <div><strong>GESTION DOTACION: </strong> {{ gestion_dotacion }}</div>
                        <div><strong>PROCEDENCIA: </strong> {{ procedencia }}</div>
                        <div><strong>OBSERVACIONES: </strong> {{ observaciones }}</div>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn text @click="cerrarDialogo">Cerrar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    <!-- </v-parallax> -->
</template>

<script>
import pdfMake from "pdfmake/build/pdfmake";
//import pdfFonts from "pdfmake/build/vfs_fonts";
import { defineComponent } from "vue";
import ResarcimientosCertEjLista from "@/services/Certificados";
import { VDataTable } from "vuetify/labs/VDataTable";
import Usuario from "@/services/Usuario";
import verdeImage from "@/assets/images/mindef.jpg";

async function imageToBase64(imagePath) {
  const response = await fetch(imagePath);
  const blob = await response.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export default defineComponent({
    name: "AdminPage",
    components: {
        VDataTable,
    },
    data() {
        var registros;
        const personal = new ResarcimientosCertEjLista();
        return {
            verdeImage: verdeImage,
            id : null,
            carnet: "",
            gestion_certificado:'2024',
            cuenta_mindef: '1-24246087',
            registro_rubro:'15910',
            codigo_persona: "",
            nro_pistola: "",
            calibre: "",
            marca: "",
            modelo: "",
            gestion_dotacion: "",
            num_cargadores: "",
            procedencia: "",
            observaciones: "",
            estado: "",
            tipo_certificado: "",
            tipo_documento: "",
            cantidad:"",
            descripcion:"",
            gestiones: ["2023", "2024", "2025", "2026", "2027", "2028"],
            estados: ["BUEN ESTADO", "ESTADO REGULAR", "MAL ESTADO"],
            item_cantidad:["1 (Una)","1 (Un)","2 (Dos)"],
            item_descripcion:["Pistola","Cargador de Pistola","Cuchillo","Sable Dorado","Sable Palteado"],
            item_tipo_certificado:["RESARCIMIENTO","REPOSICIÓN"],
            item_tipo_documento:["PISTOLA","CARGADOR DE PISTOLA","CUCHILLO","SABLE DORADO","SABLE PLATEADO"],
            registros,
            personal,
            search: "",
            headers: [
                {
                    align: "center",
                    key: "name",
                    sortable: true,
                },
                //{ key: 'codigo_dotacion', title: 'Codigo Dotacion' },
                { key: "certificado", title: "Certificado" },
                { key: "tipo_certificado", title: "Tipo" },
                { key: "gestion_certificado", title: "Gestion" },
                { key: "grado", title: "Grado" },
                { key: "nombre_completo", title: "Nombre Completo" },
                { key: "carnet", title: "Carnet" },
                { key: "tipo_documento", title: "Documento" },
                { key: "creacion", title: "F. Creacion" },
                { key: "actions", title: "Acciones", sortable: true, width: 150 },
            ],
            dialogoAbierto: false,
            showAlert: false,
            procedenciaList: [],
        };
    },
    methods: {
        async cargarImagen() {
      // Cargar la imagen como base64
      this.verdeImageBase64 = await imageToBase64(verdeImage);
    },
        cerrarDialogo() {
            this.dialogoAbierto = false;
            this.showAlert = false;
        },
        abrirDialogo(item) {
            if (item && item.id) {
                this.id = item.id;
                this.carnet = item.carnet;
                this.nombre_completo = item.nombre_completo;
                this.codigo_persona = item.codigo_persona;
                this.nro_cuchillo = item.nro_cuchillo;
                this.descripcioncu = item.descripcioncu;
                this.marca = item.marca;
                this.modelo = item.modelo;
                this.gestion_dotacion = item.gestion_dotacion;
                this.procedencia = item.procedencia;
                this.observaciones = item.observaciones;
                this.estado = item.estado;
                this.htd = item.htd;

                this.dialogoAbierto = true;

            }
        },
        async generarCertificacion(item) {
            this.id = item.id;
            this.carnet = item.carnet;
            this.tipo_certificado = item.tipo_certificado;
            this.gestion_certificado = item.gestion_certificado;
            this.certificado = item.certificado;
            this.grado = item.grado;
            this.expedido = item.expedido;
            this.cuenta_mindef = item.cuenta_mindef;
            this.registro_tesoreria = item.registro_tesoreria;
            this.registro_rubro = item.registro_rubro;
            this.cantidad = item.cantidad;
            this.descripcion = item.descripcion;
            this.tipo_documento = item.tipo_documento;
            this.htd = item.htd;

            this.nombre_completo = item.nombre_completo;
            this.codigo_persona = item.codigo_persona;
            this.nro_cuchillo = item.nro_cuchillo;
            this.descripcioncu = item.descripcioncu;
            this.marca = item.marca;
            this.modelo = item.modelo;
            this.gestion_dotacion = item.gestion_dotacion;
            this.procedencia = item.procedencia;
            this.observaciones = item.observaciones;
            this.estado = item.estado;
            const options = { day: "2-digit", month: "long", year: "numeric" };
            const dateFormatter = new Intl.DateTimeFormat("es-ES", options);

            this.created_at = dateFormatter.format(new Date(item.creacion));
                //const options = { day: "2-digit", month: "long", year: "numeric" };
                this.fecha = new Date().toLocaleDateString("es-ES", options);

                const qrCodeData = `CERTIFICADO de ${this.tipo_certificado} de pistola N°  0${this.certificado}/${this.gestion_certificado}\n perteneciente a: ${this.nombre_completo}\nes extendido en fecha ${this.fecha}`;
                const qrCodeImageDefinition = {
                    qr: qrCodeData,
                    fit: 100,
                    alignment: "right",
                    width: "auto",
                    margin: [0, 10, 5, 0],
                };

            const documentDefinition = {
                content: [
                    qrCodeImageDefinition,
                    {
                        //image: 'data:image/jpeg;base64,...',  // Aquí debes proporcionar la URL base64 de la imagen
                        image: this.verdeImageBase64,
                        width: 230, // ajusta el ancho según tus necesidades
                        alignment: "left", // ajusta la alineación según tus necesidades
                        margin: [20, -100, 0, 45], // ajusta el margen según tus necesidades
                    },
                    {
                        text: `CERTIFICADO DE ${this.tipo_certificado} N°  0${this.certificado}/${this.gestion_certificado}`,
                        style: "header",
                        alignment: "center",
                        margin: [0, 0, 0, 0],
                    },
                    {
                        text: "La Unidad de Material Bélico del Ministerio de Defensa, en atención a la solicitud presentada por el Interesado:",
                        style: "body", // Puedes definir un estilo específico para este texto si lo deseas.
                        margin: [35.05, 10, 35.05, 0], // Ajusta el margen superior según tus necesidades.
                    },
                    {
                        text: "C E R T I F I C A:",
                        style: "subheader", // Puedes definir un estilo específico para este texto si lo deseas.
                        margin: [45.05, 10, 7, 0], // Ajusta el margen superior según tus necesidades.
                        bold: true,
                    },
                    {
                        text: `Al Señor: ${this.grado} ${this.nombre_completo}\n con Cedula de Identidad: ${this.carnet} ${this.expedido}.`,
                        style: "body",
                        alignment: "center",
                        margin: [0, 0, 0, 20],
                    },
                    {
                        text: `EL DEPÓSITO BANCARIO EN LA CUENTA\n(VARIOS) DEL  MINISTERIO DE DEFENSA. ${this.cuenta_mindef}\nREGISTRÓ DE TESORERÍA Nº ${this.registro_tesoreria}\nREGISTRO DE RUBRO Nº ${this.registro_rubro}.`,
                        style: "subheader",
                        alignment: "center",
                    },
                    {
                        text: `Realizó el RESARCIMIENTO ECONÓMICO por concepto de ${this.cantidad}  ${this.descripcion}\n de acuerdo al siguiente detalle:`,
                        style: "body",
                        margin: [35.05, 10, 35.05, 0],
                    },
                    {
                        text: `${this.tipo_documento}`,
                        style: "subheader", // Puedes definir un estilo específico para este texto si lo deseas.
                        margin: [45.05, 10, 7, 0], // Ajusta el margen superior según tus necesidades.
                        bold: true,
                    },
                    {
                        text: ` DESCRIPCIÓN: ${this.descripcioncu} \nMODELO: ${this.modelo}\nSERIE: ${this.nro_cuchillo}\nINDUSTRIA:${this.procedencia}`,
                            style: "body", // Puedes definir un estilo específico para este texto si lo deseas.
                            margin: [200.05, 10, 7, 0], // Ajusta el margen superior según tus necesidades.
                        },
                        {
                            text: "Advertencia",
                            style: "body",
                            margin: [35.05, 10, 35.05, 0],
                            bold: true,
                        },
                        {
                            text: "-	El presente Certificado es válido solo para trámites administrativos dentro las FF.AA.\n-	Cualquier alteración, borrón, raspadura o enmienda, anula el presente Certificado.",
                            style: "body",
                            margin: [35.05, 10, 35.05, 0],
                            fontSize: 10,
                            bold: true,
                        },
                        {
                            //text: `La Paz, ${this.fecha}`, // Aquí se utiliza la propiedad fecha
                            text: `La Paz, ${this.created_at}`,
                            style: "subheader",
                            alignment: "right",
                            fontSize: 12,
                            margin: [35.05, 10, 35.05, 0],
                        },
                        {
                            text: `${this.firma1}`,
                            style: "subheader",
                            alignment: "center",
                            fontSize: 12,
                            margin: [-230, 60, 35, 50],
                        },
                        {
                            text: `RESPONSABLE DE UNIDAD`,
                            style: "subheader",
                            alignment: "center",
                            bold: true,
                            fontSize: 12,
                            margin: [-230, -50, 35, 50],
                        },
                        {
                            text: `${this.firma2}`,
                            style: "subheader",
                            alignment: "center",
                            fontSize: 12,
                            margin: [250, -80, 35, 50],
                        },

                         
                        {
                            text: `DIRECTOR GENERAL DE LOGÍSTICA`,
                            style: "subheader",
                            alignment: "center",
                            bold: true,
                            fontSize: 12,
                            margin: [250, -50, 35, 50],
                        },
                        {  
                        text: (`URC/imq \nHTD.${this.htd} \nCc.Arch`),
                        alignment: "left",
                        fontSize: 10,
                        margin: [35.5, 0, 355.05, 10],                        
                        },
                        
                        // Agrega más contenido según sea necesario
                    ],

                    styles: {
                        header: {
                            fontSize: 16,
                            bold: true,
                            margin: [0, 56.7, 0, 20],
                        },
                        subheader: {
                            fontSize: 14,
                            margin: [0, 0, 0, 10],
                        },
                        body: {
                            fontSize: 12,
                        },
                    },
                };

                // Genera y descarga el PDF
                pdfMake.createPdf(documentDefinition).open();
            
            
        },
    },
    

    async created() {
        await this.cargarImagen(); // Llama a cargarImagen al crear el componente
    this.registros = await this.personal.listacertificadosresarcimientosaereacu();
    // ... (resto de tu lógica)

        this.registros = await this.personal.listacertificadosresarcimientosaereacu();
        //console.log("Estos son los registros",this.registros);
        this.registros.forEach((registro, index) => {
            registro.num = index + 1;
        });
        try {
            const firmasrol = new Usuario();

            // Obtener usuarios por el primer rol (roleId = 11)
            const roleId1 = 11;
            const response1 = await firmasrol.obtenerUsuariosPorRol(roleId1);

            console.log("Este es mi respuesta de Usuario para roleId1", response1);

            if (response1 && response1.length > 0) {
                const primerusuario1 = response1[0].nombres;
                console.log("Este es mi primerusuario para roleId1", primerusuario1);
                this.firma1 = primerusuario1;
                console.log("Esta es la firma para roleId1", this.firma1);
            } else {
                console.error(
                    "La respuesta del servicio para roleId1 no contiene datos"
                );
            }

            // Obtener usuarios por el segundo rol (roleId = 12)
            const roleId2 = 12;
            const response2 = await firmasrol.obtenerUsuariosPorRol(roleId2);

            console.log("Este es mi respuesta de Usuario para roleId2", response2);

            if (response2.length > 0) {
                const primerusuario2 = response2[0].nombres;
                console.log("Este es mi primerusuario para roleId2", primerusuario2);
                this.firma2 = primerusuario2;
                console.log("Esta es la firma para roleId2", this.firma2);
            } else {
                console.error(
                    "La respuesta del servicio para roleId2 no contiene datos"
                );
            }
        } catch (error) {
            console.error("Error al obtener usuarios por rol:", error);
        }
    },
});
</script>
